import * as React from "react";
import { isEqual } from "lodash";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import {
  IXGridProps,
  TXGridProps,
  XGridProps,
} from "../../../utils/interfaces/containers/XGrid.interfaces";
import { XElementConfig } from "../../../utils/interfaces/Elements/XElement.interfaces";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { TUseXElement, useXElement } from "../../../hooks/useXElement";
import { TDynamicXElement } from "../../../utils/types/core/DynamicXElement";

import XGridCore from "./core";
import XStack from "../XStack/prod";
import XCarousel from "../XCarousel/prod";
import XImage from "../../elements/XImage";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XGridProd: React.FC<XGridProps> = ({ config = {} as XElementConfig }) => {
  // WE TRACK THE BREAK POINTS CHANGES
  const breakpoint = useBreakpoint();

  // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
  const { xElement } = useXElement<TUseXElement<TXGridProps>>(config.index);

  // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
  if (!xElement || Object.keys(xElement).length === 0) return null;

  // WE GET ALL DEVICES PROPS AS VALUE
  const { value } = xElement;

  // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
  const valueAtBreakPoint = getValueOnBreakpoint<IXGridProps>(
    value as any,
    breakpoint
  );

  return (
    <XStack config={config}>
      <XGridCore
        index={config.index}
        props={valueAtBreakPoint}
        DynamicXElement={DynamicXElement}
      />
    </XStack>
  );
};

export default React.memo(XGridProd, compareProps);

const DynamicXElement: TDynamicXElement = React.memo(({ index, hierachy }) => {
  const { xElement: element, setXElement } =
    useXElement<TUseXElement<any>>(index);

  const xElement = element ?? {};

  React.useEffect(() => {
    setXElement({
      ...xElement,

      hierachy: hierachy + "-" + xElement.name,
    });
  }, [index]);

  switch (xElement.name) {
    case "XStack":
      return <XStack config={{ index }} />;

    case "XCarousel":
      return <XCarousel config={{ index }} />;

    case "XImage":
      return <XImage config={{ index }} />;

    case "XGrid":
      return <XGridProd config={{ index }} />;

    default:
      return null;
  }
}, compareProps);
